import {ButtonWithIcon} from '@/components/atoms'
import {FileUploadWithModal, UploadMediaModal} from '@/components/organisms'
import {useProductButtonContainer} from './ProductButtonContainer-hook'

export const ProductButtonContainer = () => {
  const {
    isModal,
    toggleModal,
    setFormData,
    formData,
    toggleMultipleImagesModal,
    isMultipleImagesModal,
    onDownloadProductEnrichmentTemplate,
  } = useProductButtonContainer()
  return (
    <div className="productListBtnSection mb-6 mt-9 flex justify-between gap-5">
      <div>
        <ButtonWithIcon
          handleButton={() => toggleModal(true)}
          iconLeading="add_box"
          uiSchema={{
            title: 'Upload Product list',
            size: 'medium',
            variant: 'primary',
          }}
        />
        <ButtonWithIcon
          handleButton={() => toggleMultipleImagesModal(true)}
          iconLeading="add_box"
          uiSchema={{
            title: 'Multiple Images',
            size: 'medium',
            variant: 'primary',
          }}
        />
      </div>
      <div>
        <ButtonWithIcon
          handleButton={onDownloadProductEnrichmentTemplate}
          iconLeading="file_download"
          uiSchema={{
            title: 'Product List Template',
            size: 'medium',
            isDark: true,
            variant: 'secondary',
          }}
        />
      </div>
      <FileUploadWithModal
        openUpload={isModal}
        setOpenUpload={toggleModal}
        setFormData={setFormData}
        formData={formData}
        title="Upload Product List"
        showTertiaryButton={true}
        uploadFor={'product'}
        isCsvValidationRequired={true}
        isTemplateUpload={true}
        label={'Upload product file'}
        toastMessage={'File has successfully been uploaded and the status can be checked in Upload History'}
      />

      <UploadMediaModal
        openUpload={isMultipleImagesModal}
        setOpenUpload={toggleMultipleImagesModal}
        title="Upload Media"
        showTertiaryButton={true}
        formData={formData}
        setFormData={setFormData}
        entityType="product"
      />
    </div>
  )
}
